import { render, staticRenderFns } from "./CreateStudioInfo.vue?vue&type=template&id=33af653c&scoped=true"
import script from "./CreateStudioInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioInfo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioInfo.vue?vue&type=style&index=0&id=33af653c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af653c",
  null
  
)

export default component.exports